import { NgAnimation } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgAnimation({
    token: Token.KbRise,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbRise implements ng.animate.IAnimateCallbackObject {
    constructor(
        private $timeout: ng.ITimeoutService
    ) {

        let duration = (distance: number) => {
            return Math.max(Math.min(distance / 2, 350), 150);
        };

        let show = (element: JQuery, done) => {
            let origOpacity = element.css("opacity");
            let origOverflow = element.css("overflow");
            element.css("opacity", 0);
            element.removeClass("ng-hide");
            let finalSetHeight = element.hasClass("kb-rise--full-height") ? element.css("max-height") : "auto";
            element.css("height", finalSetHeight);
            let autoHeight: any = element.height();
            if (!autoHeight) autoHeight = "95%";
            element.height(0);
            element.css("opacity", origOpacity);
            element.animate({ height: autoHeight }, duration(autoHeight), () => {
                element.css("height", finalSetHeight);
                done();
            });
        };

        let hide = (element, done) => {
            this.autoHeight = element.height();

            element.animate({ height: 0 }, duration(this.autoHeight), () => {
                element.css("height", 0);
                done();
            });
        };

        this.beforeAddClass = (element, className, done) => {
            if (className == "ng-hide") {
                hide(element, done);
            }
        };
        this.removeClass = (element, className, done) => {
            if (className == "ng-hide") {
                show(element, done);
            }
        };
        this.enter = (element, done) => {
            show(element, done);
        };
        this.leave = (element, done) => {
            hide(element, done);
        };
    }

    private autoHeight: number;
    public beforeAddClass: (element, className, done) => void;
    public removeClass: (element, className, done) => void;
    public enter: (element, done) => void;
    public leave: (element, done) => void;
}

// export class kbSlide extends ngAnimation {
//    public injection(): any[] {
//        return [
//            Token.$Timeout,
//            ($timeout) => { return new kbSlide($timeout) }
//        ]
//    }

//    constructor($timeout: ng.ITimeoutService) {
//        super();

//        var show = (element: ng.IAugmentedJQuery , done) => {
//            element.removeClass("ng-hide");
//            element.css("width", "auto");
//            var autoWidth: any = element.width();
//            if (!autoWidth) autoWidth = "95%";
//            element.width(0);
//            element.animate({ "width": autoWidth }, 150, "linear", () => {
//                element.css("width", "auto");
//                done();
//            });
//        }

//        var hide = (element: ng.IAugmentedJQuery, done) => {
//            this.autoWidth = element.width();

//            element.animate({ "width": 0 }, 150, () => {
//                element.css("width", 0);
//                done();
//            });
//        }

//        this.beforeAddClass = (element: ng.IAugmentedJQuery, className: string, done) => {
//            if (className == "ng-hide") {
//                hide(element, done);
//            }
//        }

//        this.removeClass = (element: ng.IAugmentedJQuery, className: string, done) => {
//            if (className == "ng-hide") {
//                show(element, done);
//            }
//        }

//    }

//    private autoWidth: number;
// }

// export class kbFade extends ngAnimation {
//    public injection(): any[] {
//        return [
//            () => { return new kbFade() }
//        ]
//    }

//    constructor() {
//        super();

//        this.addClass = (element, className, done) => {
//            if (className == "ng-hide") {
//                var origOpacity = element.css("opacity");

//                element.animate({ "opacity": 0 }, 150, () => {
//                    element.hide();
//                    element.css("opacity", origOpacity);
//                    done();
//                });
//            }
//        }
//        this.removeClass = (element, className, done) => {
//            if (className == "ng-hide") {
//                var origOpacity = element.css("opacity");
//                element.css("opacity", 0);
//                element.show();

//                var to = "1";
//                if (origOpacity && origOpacity != "0") {
//                    to = origOpacity;
//                }

//                element.animate({ "opacity": to }, 150, () => {
//                    element.show();
//                    element.css("opacity", to);
//                    done();
//                });
//            }
//        }

//    }
// }
